module.exports = __webpack_public_path__ + "img/invoice.bee02c0a.png";